import { Directive, HostListener, HostBinding, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDropdownForModal]'
})
export class DropdownForModalDirective {
  constructor(private elementRef: ElementRef) { }

  private dropdownParentEl = this.elementRef.nativeElement.closest('.dropdown');

 /* @HostListener('mouseenter') toggleOpen(){
    this.dropdownParentEl.querySelector(".dropdown-menu").classList.add('show');
  }
   @HostListener('mouseleave') toggleClose(){
    this.dropdownParentEl.querySelector(".dropdown-menu").classList.remove('show');
  }
 */
  @HostListener('click') toogleOpen() {
    if (this.dropdownParentEl.querySelector(".dropdown-menu")) {
      this.dropdownParentEl.querySelector(".dropdown-menu").classList.toggle('show');
    }
  }
}
